import { AppIcons } from '@backrs_ui/common-ui';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ALL_SEARCH_CATEGORIES } from './search.filters';

/** The different categories of search pages, like scholarships, internships, etc. */
export const SEARCH_PAGE_CATEGORIES = {
  DEFAULT: 'backrs',
  SCHOLARSHIPS: 'scholarships',
  INTERNSHIPS: 'internships',
  COLLEGES: 'universities',
  // SUCCESS_DECODED: 'success_decoded',
} as const;

export type SearchPageCategory =
  (typeof SEARCH_PAGE_CATEGORIES)[keyof typeof SEARCH_PAGE_CATEGORIES];

export type Category = Readonly<{
  key: SearchCategory;
  label: string;
  isParent?: boolean;
  clearsOtherFilters?: boolean; // if true, when this filter is selected, other filters will be cleared. ex: All
  subCategories?: Category[];
}>;

/** The different parent categories of filters on search pages, like scholarships have types of scholarships, internships have industries and career paths, etc. */
export type SearchParentCategory = Readonly<{
  name: string;
  iconName: AppIcons;
  isInMoreFilters: boolean;
  categories: Category[];
}>;

/** The list of all different sub filters. The BE has a duplicate list */
export type SearchCategory =
  | (typeof ALL_SEARCH_CATEGORIES)[keyof typeof ALL_SEARCH_CATEGORIES]
  // dynamically generated categories based on BE response
  | `INTERNSHIP_CAREER_PATH_${number}`
  | `INTERNSHIP_INDUSTRY_${number}`;
